import { gql, useMutation } from '@apollo/client'

export const CREATE_FEED = gql`
  mutation ($input: FeedCreate) {
    createFeed(input: $input) {
      id
      body
      argument_type
      campaign_id
      created_at
      type
      __typename
    }
  }
`

export const useCreateFeed = () => {
  const [mutate, { data, loading, error }] = useMutation(CREATE_FEED, {
    update(cache) {
      cache.modify({
        fields: {
          getFeeds() {},
          getFeedsByCampaignId() {}
        }
      })
    }
  })

  return { mutate, data, loading, error }
}
